const faqs = [
  {
    q: '51吃瓜视频网是什么？',
    a: '51吃瓜视频是全网领先的吃瓜爆料视频聚合平台，汇集最新娱乐八卦、明星动态、社会热点等热门视频内容。通过51吃瓜官网全网最新入口，用户可以一站式浏览各类新鲜爆料视频，平台每日持续更新海量资源，是吃瓜爱好者的首选聚集地。',
  },
  {
    q: '如何找到51吃瓜官网最新入口？',
    a: '本站即为51吃瓜视频网官方首页地址。建议将本页加入浏览器收藏夹，以便随时访问。如遇域名变动，可通过搜索引擎搜索"51吃瓜视频"或"51吃瓜官网全网最新入口"找到最新官方入口。同时推荐下载51吃瓜APP，获取更稳定的访问体验。',
  },
  {
    q: '51吃瓜视频APP在哪里下载？',
    a: '您可以在本页面下方的APP下载区域扫描二维码或点击下载链接获取51吃瓜APP。APP端支持iOS和Android双平台，安装后即可享受更流畅的吃瓜体验，同时支持消息推送，让您不错过任何热门爆料。',
  },
  {
    q: '平台内容多久更新一次？',
    a: '51吃瓜视频保持7×24小时不间断更新机制，编辑团队全天候追踪全网热点事件。娱乐圈动态、社会新闻、明星八卦等各类吃瓜内容均在第一时同步上线，确保用户随时访问都能看到最新最热的爆料视频。',
  },
];

export default function FaqSection() {
  return (
    <section id="faq" className="py-12 md:py-16 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-[1024px] mx-auto">
        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 mb-3">
            常见问答
          </h2>
          <p className="text-foreground-500 text-sm max-w-lg mx-auto">
            关于51吃瓜视频的常见问题，帮您快速了解平台
          </p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          {faqs.map((item, i) => (
            <div
              key={i}
              className="bg-background-50 border border-background-200/70 rounded-xl p-5 md:p-6 hover:border-primary-200/60 transition-colors"
            >
              <h3 className="font-heading text-base text-foreground-900 mb-2 flex items-start gap-3">
                <span className="text-primary-500 flex-shrink-0 mt-0.5">
                  <i className="ri-question-answer-line"></i>
                </span>
                {item.q}
              </h3>
              <p className="text-foreground-600 text-sm leading-relaxed pl-8">
                {item.a}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}